import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';

/*
  Generated class for the CapReport page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-CapReport',
    templateUrl: 'CapReport.html'
})
export class CapReportPage {

    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider) { }


    public ReportData: any = [];
    ionViewDidLoad() {
        console.log('ionViewDidLoad CapReportPage');
        this.ReportData.splice(0, this.ReportData.length);
        this.serviceProvider.Get("/ISPA_CapReport/0", true).then((res: any) => {
            this.ReportData = res;
            console.log(res);
        });
    }

    public CTount() {
        this.ReportData.splice(0, this.ReportData.length);
        this.serviceProvider.Get("/ISPA_CapReport/0", true).then((res: any) => {
            this.ReportData = res;
            console.log(res);
        });
    }

    public Tonaj() {
        this.ReportData.splice(0, this.ReportData.length);
        this.serviceProvider.Get("/ISPA_CapReport/1", true).then((res: any) => {
            //this.ReportData = res;
            res.forEach((value, index) => {
                this.ReportData.push({
                    RowN: value.RowN,
                    cRegion: value.cRegion,
                    Kore: this.getCapacity(value.Kore),
                    KoreP: this.getCapacity(value.KoreP),
                    Gondole: this.getCapacity(value.Gondole),
                    GondoleP: this.getCapacity(value.GondoleP),
                    Navard: this.getCapacity(value.Navard),
                    NavardP: this.getCapacity(value.NavardP),
                    Ehya: this.getCapacity(value.Ehya),
                    EhyaP: this.getCapacity(value.EhyaP),
                    Zob: this.getCapacity(value.Zob),
                    ZobP: this.getCapacity(value.ZobP),
                    Kons: this.getCapacity(value.Kons),
                    KonsP: this.getCapacity(value.KonsP)
                })
            })
            console.log(res);
        });
    }
    getCapacity(value) {
        if (value == null) {
            return "";
        }
        if (value > 999999) {
            console.log(value);
            return (value / 1000000) + " م";
        }
        else if (value > 999) {
            return (value / 1000) + " ه";
        }
        else {
            return value + "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/atlas/CapReport/CapReport.ts